import { ReactComponent as First } from "Assets/Images/att-first-interaction.svg";
import { ReactComponent as Last } from "Assets/Images/att-last-interaction.svg";
import { ReactComponent as LastNonDirect } from "Assets/Images/att-last-nondirect.svg";
import { ReactComponent as Linear } from "Assets/Images/att-linear.svg";
import { ReactComponent as Position } from "Assets/Images/att-position-based.svg";
import { ReactComponent as Effected } from "Assets/Images/att-effected-interaction.svg";
import { Box, BoxProps, Typography } from "@mui/material";
import { useMemo } from "react";
import { ApiAttributionModel } from "@incendium/api";

interface IAnalyticsAttributionIconProps extends BoxProps {
  model: ApiAttributionModel;
}

function AnalyticsAttributionIcon({
  model,
  ...boxProps
}: IAnalyticsAttributionIconProps) {
  const iconRender = useMemo(() => {
    switch (model) {
      case ApiAttributionModel.FIRST:
        return <First />;
      case ApiAttributionModel.LAST:
        return <Last />;
      case ApiAttributionModel.LAST_NON_DIRECT:
        return <LastNonDirect />;
      case ApiAttributionModel.POSITION_BASED:
        return <Position />;
      case ApiAttributionModel.LINEAR:
        return <Linear />;
      case ApiAttributionModel.IMPACTED:
        return <Effected />;
      case ApiAttributionModel.EBA:
        return (
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="body1"
              color={"inherit"}
              textAlign="center"
              fontWeight={500}
              lineHeight={1}
            >
              EBA
            </Typography>
          </Box>
        );
      case ApiAttributionModel.CUSTOM:
        return (
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="body1"
              color={"inherit"}
              textAlign="center"
              fontWeight={500}
              lineHeight={1}
            >
              CUS
            </Typography>
          </Box>
        );

      default:
        return <></>;
    }
  }, [model]);

  return (
    <Box
      {...boxProps}
      sx={{
        ...boxProps.sx,
        display: "flex",
        "& svg": (boxProps?.sx as any)?.width
          ? {
            width: "100%",
            height: "auto",
          }
          : undefined,
      }}
    >
      {iconRender}
    </Box>
  );
}

export default AnalyticsAttributionIcon;
